function composeCssClasses() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return classes.filter(function (i) {
    if (!i) return false;else if (typeof i === 'string') return true;else if (typeof i.useIf === 'boolean') return i.useIf;else return true;
  }).map(function (i) {
    if (typeof i === 'string') return i;else return i.className;
  }).join(' ');
}

export { composeCssClasses };